<div>
    <!-- Main topic input -->
    <app-gyan-input
        [topic]="topic"
        (save)="saveToLocalStorage()"
        (saveTemplates)="saveToLocalStorageTemplates($event)"
        (saveKeyConcepts)="saveToLocalStorageKeyConcepts($event)"
        (saveSubTopicSources)="saveToLocalStorageSubTopicSources($event)"
        (saveSettingsParams)="saveToLocalStorageSettings($event)"
    >
    </app-gyan-input>
</div>
